import React from 'react';

const UsersListPage = React.lazy(() => import('pages/users/list'));
const UserEditPage = React.lazy(() => import('pages/users/form/edit'));
const UserCreatePage = React.lazy(() => import('pages/users/form/create'));
const UserMyProfilePage = React.lazy(() => import('/pages/users/my-profile'));
const UserActivityLogsPage = React.lazy(() => import('pages/users/activity-logs'));

const activityLogsPoliciesView = [{ resource: 'userActivityLogs', action: 'view' }];
const policiesView = [{ resource: 'users', action: 'view' }];
const policiesUpdate = [{ resource: 'users', action: 'update' }];

export const definitions = [
  {
    index: true,
    policies: policiesView,
    component: <UsersListPage />
  },
  {
    path: 'new',
    policies: policiesUpdate,
    component: <UserCreatePage />
  },
  {
    path: ':userID',
    policies: policiesUpdate,
    component: <UserEditPage />
  },
  {
    path: 'activity-logs',
    policies: activityLogsPoliciesView,
    component: <UserActivityLogsPage />
  }
];

export const miscDefinitions = [
  {
    path: 'my-profile',
    component: <UserMyProfilePage />
  }
];
